var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M12 2a10 10 0 100 20 10 10 0 000-20zm-2 14V8l6.3 4-6.3 4z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }